<template>
    <v-container fluid grid-list-md>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Saldos por Deposito</h1>
                <div class="caption">
                    Muestra por empresa seleccionada los saldos discriminando por deposito
                </div>
            </v-flex>
        </v-layout>
        <v-menu v-model="lateral" :close-on-content-click="false">
            <v-btn slot="activator" flat icon>
                <v-icon>menu</v-icon>
            </v-btn>
            <form>
                <v-card>
                    <v-card-text>
                        <empresa-select v-model="d.empresa"></empresa-select>
                        <moneda-select v-model="d.moneda"></moneda-select>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuDesde"
                                :return-value.sync="menuDesde"
                                ref="menuDesde"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Desde"
                                    v-model="d.desde"
                                    prepend-icon="event"
                                    readonly></v-text-field>
                            <v-date-picker
                                    v-model="d.desde"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuDesde.save(date)"
                            ></v-date-picker>
                        </v-menu>
                        <v-menu
                                lazy
                                :close-on-content-click="false"
                                v-model="menuHasta"
                                transition="v-scale-transition"
                        >
                            <v-text-field
                                    name="desde"
                                    slot="activator"
                                    label="Hasta"
                                    v-model="d.hasta"
                                    prepend-icon="event"
                                    readonly
                                    ref="menuHasta"
                            ></v-text-field>
                            <v-date-picker
                                    v-model="d.hasta"
                                    first-day-of-week="1"
                                    locale="es-sp"
                                    scrollable
                                    @input="$refs.menuHasta.save(date)"
                            ></v-date-picker>
                        </v-menu>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn dark default @click.native="mostrar()" :loading="loading">MOSTRAR</v-btn>
                    </v-card-actions>
                </v-card>
            </form>
        </v-menu>
        <v-layout>
            <v-flex>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <highcharts style="width: 100%" :options="chartOptions"></highcharts>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import empresaSelect from '../../components/EmpresaSelect.vue'
    import monedaSelect from '../../components/MonedaSelect.vue'
    import moment from 'moment'

    export default {
        components: {empresaSelect, monedaSelect},
        data() {
            return {
                lateral: false,
                loading: false,
                menuDesde: false,
                menuHasta: false,
                empresas: [],
                monedas: [],
                d: {
                    empresa: [],
                    tipo: '',
                    desde: moment().subtract(1, 'year').format('YYYY-MM-DD'),
                    hasta: moment().format('YYYY-MM-DD')
                },
                t: {},
                chartOptions: {
                    chart: {
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                        zoomType: 'x'
                    },
                    legend: {
                        labelFormat: '{name}'
                    },
                    tooltip: {
                        pointFormat: '{series.name} | {point.compl}: Monto: <b>{point.y:,.1f}</b>'
                    },
                    title: {
                        text: 'SALDOS POR DEPOSITO'
                    },
                    xAxis: {
                        type: 'category',
                        minRange: 1
                    },
                    yAxis: {
                        title: {
                            text: 'Cantidad'
                        },
                        stackLabels: {
                            enabled: false,
                            style: {
                                fontWeight: 'bold',
                                color: 'gray'
                            }
                        }
                    },
                    plotOptions: {
                        pie: {
                            showInLegend: true,
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                color: '#000000',
                                connectorColor: '#000000',
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            }
                        }
                    },
                    series: [
                        {
                            type: 'pie',
                            name: 'Saldos',
                            data: {}
                        }
                    ]
                },
            }
        },
        methods: {
            mostrar() {
                this.loading = true;
                this.$http.post('indicadores/saldo-deposito', this.d)
                    .then(r => {
                        this.chartOptions.series[0].data = r.data.grafico;
                        this.loading = false;
                        this.lateral = false;
                    }, r => {
                        alert(r)
                        this.loading = false;
                    });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/indicadores/saldo-deposito.vue